const WorkingArea = () => import('../views/WorkingArea.vue');

export const workingAreaRoutes = [
    {
        path: '/working-area',
        name:'workingArea',
        component: WorkingArea,
    },
]